// Recent email storage constants
export const RECENT_EMAILS_KEY = 'flik.recentEmails';
export const MAX_RECENT_EMAILS = 200;

// Recent email storage utility functions
export const getRecentEmails = (): string[] => {
  try {
    const data = localStorage.getItem(RECENT_EMAILS_KEY);
    if (!data) return [];
    return JSON.parse(data);
  } catch {
    return [];
  }
};

export const addRecentEmail = (email: string) => {
  console.log('addRecentEmail called with:', email); // Debug log
  try {
    const recentEmails = getRecentEmails();
    console.log('Current recent emails:', recentEmails); // Debug log
    const normalizedEmail = email.toLowerCase().trim();

    // Remove the email if it already exists (to move it to the front)
    const filteredEmails = recentEmails.filter(
      (e) => e.toLowerCase() !== normalizedEmail,
    );

    // Add the email to the front and limit to MAX_RECENT_EMAILS
    const updatedEmails = [email, ...filteredEmails].slice(
      0,
      MAX_RECENT_EMAILS,
    );

    console.log('Updated emails list:', updatedEmails); // Debug log
    localStorage.setItem(RECENT_EMAILS_KEY, JSON.stringify(updatedEmails));
    console.log('Email saved to localStorage'); // Debug log
  } catch (error) {
    console.error('Failed to save recent email:', error);
  }
};

// Email validation function
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Remove email from recent emails
export const removeRecentEmail = (email: string) => {
  console.log('removeRecentEmail called with:', email); // Debug log
  try {
    const recentEmails = getRecentEmails();
    console.log('Current recent emails before removal:', recentEmails); // Debug log

    const normalizedEmail = email.toLowerCase().trim();
    const updatedEmails = recentEmails.filter(
      (e) => e.toLowerCase() !== normalizedEmail,
    );

    console.log('Updated emails list after removal:', updatedEmails); // Debug log
    localStorage.setItem(RECENT_EMAILS_KEY, JSON.stringify(updatedEmails));
    console.log('Email removed from localStorage'); // Debug log
  } catch (error) {
    console.error('Failed to remove recent email:', error);
  }
};
